import { defineComponent as _defineComponent } from 'vue'
import { HeadingDisplay, BaseText, Heading } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { IProductDetails } from '@/modules/products/services/products';

interface Props {
  details: IProductDetails | null;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryCardProfitabilityMain',
  props: {
    details: null
  },
  setup(__props: any) {



return { __sfc: true,HeadingDisplay, BaseText, Heading, NebraskaColors }
}

})